import { useLocaleContext, useLocaleUrl } from "@ct-react/locale";
import { Navigate } from "react-router";
import React from "react";

const NotFoundLocaleRedirect = () => {
  const { locale } = useLocaleContext();
  const { currentUrl, buildLocaleHref } = useLocaleUrl();
  return (<Navigate to={buildLocaleHref(currentUrl, locale)} replace />);
}

export default NotFoundLocaleRedirect;
